import { render, staticRenderFns } from "./OrmMessageView.vue?vue&type=template&id=b2056c2c"
import script from "./OrmMessageView.vue?vue&type=script&lang=js"
export * from "./OrmMessageView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b2056c2c')) {
      api.createRecord('b2056c2c', component.options)
    } else {
      api.reload('b2056c2c', component.options)
    }
    module.hot.accept("./OrmMessageView.vue?vue&type=template&id=b2056c2c", function () {
      api.rerender('b2056c2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ormmessage/OrmMessageView.vue"
export default component.exports